// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum KafkaDltMessageType {
  CreateAndSendOrderPaymentInstructions = "CREATE_AND_SEND_ORDER_PAYMENT_INSTRUCTIONS",
  CreateAndSendChargeChangeReceipt = "CREATE_AND_SEND_CHARGE_CHANGE_RECEIPT",
  CreateAndSendReceipt = "CREATE_AND_SEND_RECEIPT",
}
export default KafkaDltMessageType;
